import React from 'react';

const KvkkModal = ({ show, handleClose }) => {
  return (
    <div className={`modal fade ${show ? 'show d-block' : ''}`} tabIndex="-1" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
      <div className="modal-dialog modal-lg modal-dialog-centered">
        <div className="modal-content border-0 shadow-lg rounded-4 overflow-hidden">
          <div className="modal-header border-0 bg-light p-4">
            <h5 className="modal-title fw-bold text-dark">Kişisel Verilerinizin Korunması Hakkında</h5>
            <button type="button" className="btn-close shadow-none" onClick={handleClose}></button>
          </div>
          <div className="modal-body p-4 pt-0">
            <div className="text-secondary lh-lg" style={{ fontSize: '0.95rem' }}>
              <p className="fw-bold text-dark mb-3">Değerli Paydaşımız,</p>
              <p>
                İdeal Kültür Yayıncılık (İDEAL) olarak, 6698 sayılı KVKK kapsamında verilerinizin güvenliğine önem veriyoruz. Platformumuzu kullanırken paylaştığınız veriler şu çerçevede işlenmektedir:
              </p>
              <ul className="list-unstyled mb-4">
                <li className="mb-2 d-flex align-items-start">
                  <span className="me-2 text-primary">•</span>
                  <span><strong>İşleme Amacı:</strong> Yayıncılar için sözleşme süreçlerinin yönetilmesi, eserlerin veri tabanına eklenmesi ve indeksleme hizmetinin sunulması; kullanıcılar için ise erişim yetkilerinin tanımlanması amacıyla işlenir.</span>
                </li>
                <li className="mb-2 d-flex align-items-start">
                  <span className="me-2 text-primary">•</span>
                  <span><strong>Veri Paylaşımı:</strong> Verileriniz, yasal zorunluluklar dışında üçüncü kişilere açıklanmaz veya değiştirilmez. Ancak, sistemin doğası gereği uluslararası arama motorları tarafından indekslenen künye bilgileri (Editör ismi vb.) kamuya açık hale gelebilir.</span>
                </li>
                <li className="mb-2 d-flex align-items-start">
                  <span className="me-2 text-primary">•</span>
                  <span><strong>Veri Saklama ve Silme:</strong> Yayının kaldırılması talep edildiğinde, veriler sistem işleyişini aksatmayacak şekilde kademeli olarak silinir.</span>
                </li>
                <li className="mb-2 d-flex align-items-start">
                  <span className="me-2 text-primary">•</span>
                  <span><strong>Haklarınız:</strong> Verilerinizin işlenip işlenmediğini öğrenme ve düzeltme talep etme hakkınız saklıdır.</span>
                </li>
              </ul>
              <div className="p-3 bg-light rounded-3 border-start border-4 border-primary">
                <p className="mb-0 small italic">
                  <strong>Not:</strong> Bu onay, platform üzerindeki tüm işlemlerinizde ve tarafımıza ilettiğiniz tebligat adresleri üzerinden yapılacak iletişimlerde geçerlidir.
                </p>
              </div>
            </div>
          </div>
          <div className="modal-footer border-0 p-4 pt-0">
            <button type="button" className="btn btn-primary px-4 rounded-pill fw-medium" onClick={handleClose}>Anladım</button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default KvkkModal;
